import { useSelector } from "react-redux";
import { USER_STORAGE_KEY } from "../../constants/general";
import { useHandleUnauthorized } from "../../hooks/useHandleUnauthorized";
import { useInterval } from "../../hooks/useInterval";
import { sessionExpirationTimeSelector } from "../../selectors/entities";

// Frequency to check session expiration time against current time
const SESSION_CHECK_INTERVAL_MS = 1000;

/*  Check whether we've passed the current session's expiration time on a running interval.
    When the expiration time has passed, fully clear the state and redirect to the homepage.
*/
export default function SessionExpirationTimer() {
  const clearStore = useHandleUnauthorized('login'); 

  const localStorageUser = JSON.parse(localStorage.getItem(USER_STORAGE_KEY));
  const sessionExpTimeLs = localStorageUser ? localStorageUser.expirationTime : 0;
  const sessionExpTimeRedux = useSelector(sessionExpirationTimeSelector);
  const sessionExpTime = sessionExpTimeRedux || sessionExpTimeLs;

  useInterval(() => {
    if (sessionExpTime != null) {
      const currTimeInMs = Date.now();
      if (currTimeInMs > (sessionExpTime * 1000)) {
        clearStore();
      }
    }
  }, SESSION_CHECK_INTERVAL_MS)

  return null;
}